import React from 'react';

/**
 * Sélecteur de lien d'étape : aucun / page CRM (slug) / URL externe.
 * link = { kind:'crm'|'url'|null, value, label }
 */
export default function WorkflowLinkPicker({ link, onChange }) {
  const kind = link?.kind || '';
  const value = link?.value || '';

  const setKind = (k) => {
    if (!k) return onChange(null);
    onChange({ kind: k, value: '', label: '' });
  };
  const setValue = (v) => onChange({ ...(link || { kind }), kind: kind || 'url', value: v });

  return (
    <div className="wf-link-picker">
      <select className="wf-link-kind" value={kind} onChange={(e) => setKind(e.target.value)}>
        <option value="">Aucun</option>
        <option value="crm">Page CRM</option>
        <option value="url">URL externe</option>
      </select>
      {kind === 'crm' && (
        <input
          className="wf-link-value"
          placeholder="slug de page (ex. leads-services)"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      )}
      {kind === 'url' && (
        <input
          className="wf-link-value"
          type="url"
          placeholder="https://…"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      )}
    </div>
  );
}
